/** @format */

import React, { Fragment, useState } from "react";
import ProfileHeader from "./components/ProfileHeader";
import ProfileContent from "./components/ProfileContent";
import ProfileTabs from "./components/ProfileTabs";
import { FadeLoader } from "react-spinners";

import FellowLayout from "views/fellows/Fellow";
import { useGetFellowProfileQuery } from "store/services/adminAPI";

const FellowProfile = () => {
  const {
    data: fellow,
    isLoading: fetchingFellow,
    refetch,
    isFetching,
  } = useGetFellowProfileQuery();
  const [activeTab, setActiveTab] = useState("personal");

  return (
    <FellowLayout>
      <Fragment>
        {/* {fetchingFellow || isFetching  ? ( */}
        {fetchingFellow ? (
          <div className="d-flex justify-content-center align-items-center height-15 bg-white ">
            <FadeLoader color="#36d7b7" />
          </div>
        ) : (
          <Fragment>
            <ProfileHeader
              profileInfo={fellow?.data?.profile}
              refetch={refetch}
              isFetching={isFetching}
            />
            <ProfileTabs setActiveTab={setActiveTab} activeTab={activeTab} />
            <ProfileContent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              fellow={fellow}
            />
          </Fragment>
        )}
      </Fragment>
    </FellowLayout>
  );
};

export default FellowProfile;


